import React from "react";
import PropTypes from "prop-types";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";

// core components
import dashboardStyle from "assets/jss/material-dashboard-pro-react/views/dashboardStyle";

import Info from "granular/Dashboard/info.js";
import ReferencesData from "granular/Dashboard/reference_data.js";
import WorkspaceList from "granular/Dashboard/workspacelist.js";

class Dashboard extends React.Component {
  state = {
    value: 0
  };
  handleChange = (event, value) => {
    this.setState({ value });
  };
  handleChangeIndex = index => {
    this.setState({ value: index });
  };
  render() {
    //const { classes } = this.props;
    return (
      <div>
        <Info />
        <ReferencesData />
        <WorkspaceList />
      </div>
    );
  }
}

Dashboard.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(dashboardStyle)(Dashboard);
